export enum RoleTypes {
    System = 'SystemRole',
    Tenant = 'TenantRole'
}

/**
 * All of the AppRoles that are available in the system.
 */
export enum SystemRoles {
    GlobalAdmin = 'SystemRole:GlobalAdmin',
    MemberAdmin = 'SystemRole:MemberAdmin',
    MemberViewer = 'SystemRole:MemberViewer',
    //AnalyticsAdmin = 'SystemRole:AnalyticsAdmin',
    //BillingAdmin = 'SystemRole:BillingAdmin',
    //RecordsAdmin = 'SystemRole:RecordsAdmin',
    //SearchAdmin = 'SystemRole:SearchAdmin',
    //UserAdmin = 'SystemRole:UserAdmin',
    //UserViewer = 'SystemRole:UserViewer',
    //PhysicalRecordsAdmin = 'SystemRole:PhysicalRecordsAdmin',
    //DiscoveryAdmin = 'SystemRole:DiscoveryAdmin',
    //BasicUser = 'SystemRole:BasicUser',
    SystemAdmin = 'SystemRole:SystemAdmin',
    TenantAdmin = 'SystemRole:TenantAdmin',
    TenantViewer = 'SystemRole:TenantViewer',
    AuditAdmin = 'SystemRole:AuditAdmin',
    AuditViewer = 'SystemRole:AuditViewer'
};
export enum TenantRoles {
    GlobalAdmin = 'TenantRole:GlobalAdmin',
    SystemAdmin = 'TenantRole:SystemAdmin',
    AuditAdmin = 'TenantRole:AuditAdmin',
    AuditViewer = 'TenantRole:AuditViewer',
    BasicUser = 'TenantRole:BasicUser',
    DiscoveryAdmin = 'TenantRole:DiscoveryAdmin',
    PhysicalRecordsAdmin = 'TenantRole:PhysicalRecordsAdmin',
    RecordsAdmin = 'TenantRole:RecordsAdmin',
    SearchAdmin = 'TenantRole:SearchAdmin',
    UserAdmin = 'TenantRole:UserAdmin'
    //MemberAdmin = 'TenantRole:MemberAdmin',
    //MemberViewer = 'TenantRole:MemberViewer',
    //AnalyticsAdmin = 'TenantRole:AnalyticsAdmin',
    //BillingAdmin = 'TenantRole:BillingAdmin',
    //UserViewer = 'TenantRole:UserViewer',
    //ConfigurationAdmin = 'TenantRole:ConfigurationAdmin',
};

/**
 * The AppRoles that are available to the Configuration Admin.
 */
export const systemConfigurationAdminRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    //SystemRoles.ConfigurationAdmin
];

/**
 * The AppRoles that are available to the System Admin.
 */
export const systemSystemAdminRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    SystemRoles.SystemAdmin
]

/**
 * The AppRoles that are available to the Diagnostics Admin.
 */
export const systemDiagnosticsAdminRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    //SystemRoles.DiagnosticsAdmin
];

/**
 * The AppRoles that are available to the Diagnostics Users.
 */
export const systemDiagnosticsRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    //SystemRoles.DiagnosticsAdmin,
    //SystemRoles.DiagnosticsViewer
];

/**
 * The AppRoles that are available to the Tenant Admin.
 */
export const systemTenantAdminRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    SystemRoles.TenantAdmin
];

/**
 * The AppRoles that are available to the Tenant Users.
 */
export const systemTenantRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    SystemRoles.TenantAdmin,
    SystemRoles.TenantViewer
];

/**
 * The AppRoles that may read a tenant's lifecycle records: the provisioning
 * and deletion run status, a Deleted tenant's deletion record, and its
 * deletion certificate.
 */
export const systemTenantLifecycleRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    SystemRoles.SystemAdmin,
    SystemRoles.TenantAdmin
];

/**
 * The AppRoles that may search system-scope audit entries by user. GlobalAdmin
 * only: the Audit service refuses AuditAdmin and AuditViewer on this search.
 */
export const systemUserAuditRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin
];

/**
 * The AppRoles that may read system-scope audit entries.
 */
export const systemAuditRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    SystemRoles.AuditAdmin,
    SystemRoles.AuditViewer
];

/**
 * The AppRoles that are available to the Member Admin.
 */
export const systemMemberAdminRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    SystemRoles.MemberAdmin
];

/**
 * The AppRoles that are available to the Member Users.
 */
export const systemMemberRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin,
    SystemRoles.MemberAdmin,
    SystemRoles.MemberViewer
];

/**
 * The AppRoles that are available to the Analytics Users.
 */
export const systemAnalyticsRoles: SystemRoles[] = [
    SystemRoles.GlobalAdmin
];

/**
 * Checks if user has at least one of the required AppRoles
 * 
 * @param requiredAppRoles - the permitted roles
 * @param userAppRoles - the roles the user has
 * @returns true if the user has at least one of the required roles, false otherwise
 */
export function hasAnyAppRole(requiredAppRoles: string[] = [], userAppRoles: string[] = []): boolean {
    if (Array.isArray(requiredAppRoles) && Array.isArray(userAppRoles)) {
        return requiredAppRoles.some((appRole, idx) => {
            return userAppRoles.includes(appRole);
        });
    }

    return false;
}

/**
 * Checks if user has all of the required AppRoles
 * 
 * @param requiredAppRoles - the permitted roles
 * @param userAppRoles - the roles the user has
 * @returns true if the user has all of the required roles, false otherwise
 */
export function hasAllAppRoles(requiredAppRoles: string[] = [], userAppRoles: string[] = []): boolean {
    if (Array.isArray(requiredAppRoles) && Array.isArray(userAppRoles)) {
        return requiredAppRoles.every((appRole) => {
            return userAppRoles.includes(appRole);
        });
    }

    return false;
}